export default __webpack_public_path__ + "static/media/menu_qr_active_left.5e143d8d.svg";